
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-fill",attrs:{"d":"M12 32h5v7h-5zM20 32h5v7h-5zM28 32h5v7h-5zM13 23h21v4H13z","fill":"#D0EFEC"}}),_c('path',{staticClass:"i-Rectangle 54",attrs:{"stroke":"#234652","d":"M19 12H9v33h29V12h-8.5"}}),_c('g',{staticClass:"i-Group 8",attrs:{"stroke":"#234652"}},[_c('path',{staticClass:"i-Line 39",attrs:{"d":"M13 31.5h5"}}),_c('path',{staticClass:"i-Line 40",attrs:{"d":"M13 34.5h5"}}),_c('path',{staticClass:"i-Line 41",attrs:{"d":"M13 37.5h5"}}),_c('path',{staticClass:"i-Line 43",attrs:{"d":"M21 31.5h5"}}),_c('path',{staticClass:"i-Line 44",attrs:{"d":"M21 34.5h5"}}),_c('path',{staticClass:"i-Line 45",attrs:{"d":"M21 37.5h5"}}),_c('path',{staticClass:"i-Line 47",attrs:{"d":"M29 31.5h5"}}),_c('path',{staticClass:"i-Line 48",attrs:{"d":"M29 34.5h5"}}),_c('path',{staticClass:"i-Line 49",attrs:{"d":"M29 37.5h5"}})]),_c('g',{staticClass:"i-dollar-sign",attrs:{"stroke":"#234652"}},[_c('path',{staticClass:"i-Line 124",attrs:{"d":"M24.267 3.241v2.116"}}),_c('path',{staticClass:"i-Line 125",attrs:{"d":"M24.267 18.895v2.116"}}),_c('path',{staticClass:"i-Ellipse 603",attrs:{"d":"M20.773 15.507a3.354 3.354 0 1 0 6.026-2.285c-1.13-1.5-2.777-1.027-4.4-2.226-.417-.36-.891-.898-1.066-1.421a3.07 3.07 0 1 1 5.888-1.723"}})])])
          )
        }
      }
    